export const kpiData = [
  {name: 'AcceptanceSpeed', translationKey: 'buyer.kpis.acceptanceSpeed'},
  {name: 'PaymentSpeed', translationKey: 'buyer.kpis.paymentSpeed'},
  {name: 'Refusal', translationKey: 'buyer.kpis.refusal'},
  {name: 'NoReaction', translationKey: 'buyer.kpis.noReaction'}
];
